import React from 'react';
import './components.css';
import Bitmap from './media/bitmap2.png';
// import Tracking from './media/tracking.png';
import { Link } from 'react-router-dom'

const TrackingMain = () => {
	return (
		<div className="track-container" >
			<Link className='a-h' to='tracking'>
				<span>Отследить отправление</span>
			</Link>
		</div>
)
};

export default TrackingMain; 
